import React from 'react';
import { Spinner } from './StarLoader.styles';
import { propTypes, defaultProps, propDescriptions } from './StarLoader.props';

const StarLoader = ({ color, size, dataId }) => <Spinner data-id={dataId} data-testid={dataId} {...{ color, size }} />;

StarLoader.propTypes = propTypes;
StarLoader.defaultProps = defaultProps;
StarLoader.propDescriptions = propDescriptions;

export default StarLoader;
